<!-- Page Wrapper -->
<div id="wrapper">
  <app-sidebar></app-sidebar>

  <!-- End of Sidebar -->

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">

    <!-- Main Content -->
    <div id="content">

      <!-- Topbar -->
      <app-header></app-header>
      <!-- End of Topbar -->

      <!-- Begin Page Content -->
      <div class="container-fluid">


        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">Order List</h1>
          <!-- <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i class="fas fa-plus fa-sm text-white-50"></i> Add Product</a> -->
        </div>


        <!-- DataTales Example -->
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Order List</h6>
          </div>
          <div class="card-body">
            <!-- <div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_length" id="dataTable_length"><label>Show <select name="dataTable_length"
                        aria-controls="dataTable" class="custom-select custom-select-sm form-control form-control-sm select-pagination">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select> entries</label></div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="dataTable_filter" class="dataTables_filter">
                    <label>Search:<input type="search" class="form-control form-control-sm search-box" placeholder=""
                        aria-controls="dataTable"></label>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="table-responsive">


              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Date Created</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Items</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of orderList">
                    <td>{{item.payload.doc.data().date_created | date:'MM/dd/yyyy'}}</td>
                    <td>{{item.payload.doc.data().first_name}} {{item.payload.doc.data().last_name}}</td>
                    <td>{{item.payload.doc.data().email}}</td>
                    <td>{{item.payload.doc.data().phone}}</td>
                    <td>{{item.payload.doc.data().shipping_address}}</td>
                    <td>{{item.payload.doc.data().item_name}}</td>
                    <td>{{item.payload.doc.data().state}}</td>
                    <td><a href="javascript:void(0);" class="text-primary" (click)="editOrder(item.payload.doc.id)"><i
                      class="fa fa-fw fa-edit"></i></a></td>
                  </tr> 
                 
                </tbody>
              </table>






            </div>
            <!-- <div class="row">
              <div class="col-sm-12 col-md-5">
                <div class="dataTables_info" id="dataTable_info" role="status" aria-live="polite">Showing 1 to 10 of 57
                  entries</div>
              </div>
              <div class="col-sm-12 col-md-7">
                <div class="dataTables_paginate paging_simple_numbers" id="dataTable_paginate">
                  <ul class="pagination">
                    <li class="paginate_button page-item previous disabled" id="dataTable_previous"><a href="javascript:void(0);"
                        aria-controls="dataTable" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>
                    <li class="paginate_button page-item active"><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="1"
                        tabindex="0" class="page-link">1</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="2"
                        tabindex="0" class="page-link">2</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="3"
                        tabindex="0" class="page-link">3</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="4"
                        tabindex="0" class="page-link">4</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="5"
                        tabindex="0" class="page-link">5</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="6"
                        tabindex="0" class="page-link">6</a></li>
                    <li class="paginate_button page-item next" id="dataTable_next"><a href="javascript:void(0);" aria-controls="dataTable"
                        data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
                  </ul>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->




    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- End of Footer -->

  </div>
  <!-- End of Content Wrapper -->

</div>
<!-- End of Page Wrapper -->

<!-- Scroll to Top Button-->
<a class="scroll-to-top rounded" href="#page-top">
  <i class="fas fa-angle-up"></i>
</a>
